// The gems page's packs, and their prices as the page shows them until the backend's answer arrives
// (GET /api/gem-prices, src/lib/gem-prices.js) or when it cannot be had. The backend's table (promptchan-backend
// myapp/pricing.py) is what a checkout charges: keep these list prices equal to its BASELINE.
export const GEM_PACKS = [
  {
    id: 'price_1OliRUDGA4U10PLzo0bejrnN',
    price: '4.99',
    discountedPrice: '2.49',
    blackFridayPrice: '1.49',
    gems: 50,
    discount: '50%',
    gemId: 'small',
    crEnabled: false,
  },
  {
    id: 'price_1OliTFDGA4U10PLzkBljjTJi',
    price: '14.99',
    discountedPrice: '7.49',
    blackFridayPrice: '4.49',
    gems: 250,
    discount: '50%',
    gemId: 'medium',
    crEnabled: false,
  },
  {
    id: 'price_1OliTpDGA4U10PLzKJoC772S',
    price: '29.99',
    discountedPrice: '14.99',
    blackFridayPrice: '8.99',
    gems: 900,
    discount: '50%',
    gemId: 'large',
    crEnabled: false,
    couponEnabled: true,
  },
  {
    id: 'price_1OliUnDGA4U10PLzSoqZXFJg',
    price: '59.99',
    discountedPrice: '29.99',
    blackFridayPrice: '17.99',
    gems: 1800,
    discount: '50%',
    gemId: 'mega',
    crEnabled: false,
    couponEnabled: true,
  },
  {
    id: 'price_1OliVTDGA4U10PLzqhiN591h',
    price: '99.99',
    discountedPrice: '49.99',
    blackFridayPrice: '29.99',
    gems: 3000,
    discount: '50%',
    gemId: 'titan',
    crEnabled: true,
    couponEnabled: true,
  },
  {
    id: 'price_1OliVqDGA4U10PLzINFCqVu4',
    price: '299.99',
    discountedPrice: '149.99',
    blackFridayPrice: '89.99',
    gems: 10000,
    discount: '50%',
    gemId: 'mythic',
    crEnabled: true,
    couponEnabled: true,
  },
]
